import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import { toast } from 'sonner';
import { Heart } from '@phosphor-icons/react';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      toast.success('Login successful!');
      const userData = result.user;
      if (userData?.role === 'patient') navigate('/patient');
      else if (userData?.role === 'doctor') navigate('/doctor');
      else if (userData?.role === 'admin') navigate('/admin');
      else navigate('/');
    } else {
      toast.error(result.error || 'Login failed');
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-surface-secondary" data-testid="login-page">
      <Navbar />
      <div className="flex items-center justify-center min-h-screen pt-16 px-4">
        <div className="w-full max-w-md">
          <div className="card bg-surface p-8">
            <div className="flex items-center justify-center gap-2 font-spectral text-2xl font-semibold text-primary mb-2">
              <Heart size={32} weight="duotone" />
              SecondDoctorOpinion
            </div>
            <h2 className="text-center font-manrope text-2xl font-bold text-primary mb-6">Welcome Back</h2>

            <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-secondary mb-1">
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-2 border border-primary/20 rounded-lg bg-surface-secondary focus:outline-none focus:ring-2 focus:ring-primary/20"
                  required
                  data-testid="login-email-input"
                />
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-medium text-secondary mb-1">
                  Password
                </label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-2 border border-primary/20 rounded-lg bg-surface-secondary focus:outline-none focus:ring-2 focus:ring-primary/20"
                  required
                  data-testid="login-password-input"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full btn-primary py-3 disabled:opacity-50 disabled:cursor-not-allowed"
                data-testid="login-submit-button"
              >
                {loading ? 'Logging in...' : 'Login'}
              </button>
            </form>

            <div className="mt-6 text-center text-sm text-secondary">
              Don't have an account?{' '}
              <Link to="/register" className="text-primary font-semibold hover:underline" data-testid="login-register-link">
                Sign up
              </Link>
            </div>

            <div className="mt-6 p-4 bg-surface-secondary rounded-lg text-xs text-secondary">
              <p className="font-semibold mb-2">Test Credentials:</p>
              <div className="space-y-1">
                <p><strong>Patient:</strong> patient@mediverify.com / Patient@123</p>
                <p><strong>Doctor:</strong> doctor@mediverify.com / Doctor@123</p>
                <p><strong>Admin:</strong> admin@mediverify.com / Admin@123</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}